import script from "./video.vue?vue&type=script&lang=ts&setup=true"
export * from "./video.vue?vue&type=script&lang=ts&setup=true"

import "./video.vue?vue&type=style&index=0&id=537e27a5&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-537e27a5"]])

export default __exports__